import { fetchTranslation } from '../../../helpers/i18n';

export const getPasswordInputTranslations = () => {
  return {
    label: fetchTranslation('password'),
    placeholder: fetchTranslation('enter_password'),
    invalidMessage: fetchTranslation('password_does_not_meet_requirements'),
    requirementsText: {
      length: fetchTranslation('password_req_length'),
      uppercase: fetchTranslation('password_req_uppercase'),
      lowercase: fetchTranslation('password_req_lowercase'),
      number: fetchTranslation('password_req_number'),
      special: fetchTranslation('password_req_special')
    }
  };
};